import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

export default function SearchInput(props) {
  const { searchValue, handleSearch, handleSearchIcon, handleClearIcon } = props;
  const classes = useStyles();

  return (
    <Box className={classes.searchInner}>
      <input id='searchInput' className={classes.search} type='text' value={searchValue} onChange={handleSearch} />
      <SearchIcon onClick={handleSearchIcon} sx={{ fontSize: 24 }} className={`${classes.searchIcon} searchIcon`} />
      {!!searchValue && <ClearIcon onClick={handleClearIcon} sx={{ fontSize: 12 }} className={`${classes.clearIcon} clearIcon`} />}
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  searchInner: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '&:focus-within': {
      '& svg.searchIcon': {
        color: 'rgb(46,105,155)',
      },
    },
  },
  search: {
    border: '0',
    borderBottom: '1px solid',
    height: '32px',
    padding: '0 32px',
    boxSizing: 'border-box',
    outline: 0,
    borderRadius: 0,
    '&:focus-visible': {
      outline: '0',
    },
    width: '240px',
    fontSize: '16px',
    '&:focus': {
      // borderColor: 'rgb(46,105,155)',
      borderBottom: '3px solid rgb(46,105,155)',
    },
  },
  searchIcon: {
    position: 'absolute',
    color: theme.color.black,
  },
  clearIcon: {
    position: 'absolute',
    color: theme.color.black,
    right: 0,
    backgroundColor: '#00000020',
    borderRadius: '50%',
    padding: '2px',
  },
}));
